export default {
  translations: {
      otpDialog: {
        button: "Remove one time password",
        title: "Are you sure that you want to remove your one time password?",
        contentEmail: "Account e-mail:",
        content: "Please be aware that upon confirmation, the multi-factor authentication settings on your account will be removed. They will need to be configured again afterwards.",
        successfullyOtpPass: "One time password accepted successfully.",
        successfullyOtpPassContent: "Your one time password was accepted. Please, click on the confirm button to redirect to login and get allowed to application."
      },
      TwoFa:{
        title:"A code wan sended",
        message:"A code wan sended to your email.",
        button:"Put this code"
      },
      Novo: {
        message: 'New'
      },
      Nome: {
        message: 'Document name',
        text: 'Name',
        folder: 'Folder name',
        username: 'Username',
        workspace: 'Workspace name',
        group: 'Group name',
        validation: 'Validation Name',
        organization: 'Organization Name'
      },
      D4Sign:{
        Confi: 'D4 Sign Configuration',
        SafeBox: 'Safe Box',
        Error: 'D4Sign return error',
        Download: 'Download signed document',
        Wait: 'Wait, we prepare the link'
      },
      Sensibility:{
        word:"Sensibility",
        higth:"Higth",
        medium:"Medium",
        low:"Low"
      },
      Extencao: {
        message: 'Extension'
      },
      Editar: {
        message: 'Edit'
      },
      Excluir: {
        message: 'Remove'
      },
      Clone: {
        message: 'Clone'
      },
      Iniciais: {
        message: 'Initials'
      },
      NomeInterno: {
        message: 'Internal name'
      },
      UsuariosAdm: {
        message: 'Admin users'
      },
      ConfigWork: {
        message: 'Workspace Settings'
      },
      Salvar:{
        message: 'Save'
      },
      Deletar: {
        message: "Delete"
      },
      Resetar: {
        message: "Reset"
      },
      
      SalvarWork: {
        message: 'Save Worskpace'
      },
      CloneWork: {
        message: 'Clone Worskpace'
      },
      Cancelar: {
        message: 'Cancel'
      },
      Fechar: {
        message: 'Close'
      },
      WorkSalvo: {
        message: 'Workspace saved'
      },
      ErroAoSalvar:{
        message: 'Could not save'
      },
      CanNotClone:{
        message: 'Could not clone'
      },
      UsuariosSugeridos: {
        message: 'suggested users'
      },
      UsuariosNaoEncontradors: {
        message: 'Users not found'
      },
      SalvoOK: {
        message: 'Save Ok'
      },
      AdmOrg: {
        message: 'Organization root'
      },
      OnlyRead: {
        message: 'Only read'
      },
      SignInWithMicrosoft:{
        message: "Sign in with Microsoft"
      },
      MinDeCaracteres:{
        message: 'The name must contain 3 or more caracters'
      },
      MaxDeCaracteres:{
        message:'The name must be a maximum of 50 characters'
      },
      SalvarUsuario:{
        message:'Save users'
      },
      ExluirUsuarioValid:{
        message:'Are you sure you want to delete the user'
      },
      UserExcluido:{
        message:'User deleted.',
        error:'Error: User cant deleted.'
      },
      Continuar:{
        message:'Continue'
      },
      Usuarios:{
        message:'Users'
      },
      Org:{
        saveOk:'Organization saved'
      },
      SalvarOrg:{
        message:'Save Organization'
      },
      NomeOrg:{
        message:'Organization name'
      },
      NomeWorkspace:{
        message:'Workspace name'
      },
      ExcluidoComSucesso:{
        message:'Successfully deleted'
      },
      EditadoComSucesso:{
        message:'Successfully edited'
      },
      ConfigOrg:{
        message:'Organization Settings'
      },
      ExcluirOrg:{
        message:'Delete organization'
      },
      CertezaExcluir:{
        message:'Are you sure you want to delete?'
      },
      CertezaExcluirOrganization:{
        message:'Are you sure you want to delete this Organization?'
      },
      Workspace:{
        permission:"Workspace permissions",
        reader:"Reader",
      writer: "Writer",
      none: "None",
      deleteSucess: "Deleted Workspace",
      createSucess: "Created Workspace",
      cloneSucess: "Cloned Workspace",
      updateSuccess: "Updated Workspace",
    },
    Item: {
      permission: "Item permissions",
      reader: "Reader",
      writer: "Writer",
      none: "None",
      deleteSucess: "Deleted Item",
      deleteProblem: "Item problem on delete",
      createSucess: "Created Item",
      folow: "Folow father",
      isFolow: "Folow",
      dontFolow: "Don't folow",
      deleteBtn: "Delete ",
      editBtn: "Rename Item",
      deleteMessage: "Are you sure you want to delete?",
      deleteMessageFolder: "Are you sure you want to delete the folder?",
      deleteMessageFile: "Are you sure you want to delete the file?",
      deleteDescription: "Confirm if you really want to send {{itemName}} to the trash. You can restore it later.",
      setDraft: "Draft",
      setRelease: "Release",
      d4SignVersion: "Get signed version",
      undoDraft: "Undo Draft",
      folder: "Folder"
    },
      CertezaExcluirWorkspace:{
        message:'Are you sure you want to delete this Workspace?'
      },
      EscrevaNomeOrg:{
        message:'Enter the organization name'
      },
      NomeIncorreto:{
        message:'Wrong name'
      },
      Organizacoes:{
        message:'Organizations'
      },
      GrupoSalvo:{
        message:'Saved group'
      },
      AlterarUsuarios:{
        message:'Change users'
      },
      SalvarGrupo:{
        message:'Save Group'
      },
      GrupoExcluido:{
        message:'Excluded group.'
      },
      CertezaExcluirGrupo:{
        message:'Are you sure you want to Delete the group?'
      },
      Adicionar:{
        message:'Add'
      },
      AdicionarUsuario:{
        message:'Add user'
      },
      UsuarioDoGrupo:{
        message:'Group users'
      },
      Grupos:{
        message:'Groups'
      },
      TiposDeDocumento:{
        message:'Document Types'
      },
      ValidationRule: {
        menu: "Validation Rules",
        errorFind: "Validation rule not found",
        saveOk: "Validation rule saved",
        error: "Error saving",
        addActivity: "Add Workflow Activity",
        backOperationLabel: "Back Label",
        forwardOperationLabel: "Forward Label",
        dinamic: "Dynamic responsible",
        erroName: "Name must not be empty",
        erroBackOperationLabel: "Back label must not be empty",
        erroForwardOperationLabel: "Forward label must not be empty",
        erroItensTagUser: "There must be at least one responsible person",
        doYouWantToRemoveTheValidationRuleUsedOnTheseFiles: "Are you sure you want to remove this Validation Rule? It will no longer be possible to add documents to it. Documents already in this workflow will proceed until they are released.",
        erroTermTypes: "Error retrieving deadline types",
        NoTerm: "No deadline",
        UserTerm: "Deadline set by the user",
        ActivityTerm: "Deadline set in the activity",
        AddNewActivity: "Add new activity",
        ActivityDescriptor: "Create a new validation rule to ensure that the data meets the established criteria.",
        Consensual: "Consensual approval",
        newValidationRule: "New validation rule",
        saveValidationRule: "Save validation rule",
        validationRuleInformation: "Rule information",
        validationRuleName: "Rule name",
        validationRuleDescription: "Description",
        validationActivity: "Rule activities",
        validationRuleSteps: "Specify the steps the document must follow along the activity flow",
        MoveUp: "Move up",
        MoveDown: "Move down",
        RemoveLines: "Remove lines",
        ActivityName: "Activity name",
        ActivityResponsable: "Responsible",
        ActivityTermT: "Deadline",
        EditInformation: "Edit information",
        DeleteVr: "Do you really want to delete the validation rule?",
        ConfirmDelete: "Confirm if you really want to delete the validation rule.",
        AprovalAct: "Approval activity",
        AssignAct: "Signature activity",
        AssignActError: "Signature activity cannot have more than one responsible person.",
        ValidationruleListTitle: "Validation rule",
        ValidationRuleListDescription: "Validation rules are criteria established to verify whether the data meets the requirements.",
        ValidationRuleListCreateButton: "Create validation rule",
        SelectUser: "Select user...",
        NoValidationRule: "No validation rule has been configured.",
        NoValidationRuleText: "Define criteria to validate the data correctly.",
        UserConcensualNotAllowed: "Concensus approval only can be saved with two users."
      },
      Empity:{
        message:'Empty'
      },
      Arvore:{
        message:'Tree'
      },
      Configuracoes:{
        message:'Settings'
      },
      Expandir:{
        message:'Expand'
      },
      Diminuir:{
        message:'Decrease'
      },
      Sair:{
        message:'Logout'
      },
      AlteradoComSucesso:{
        message:'Successfully changed'
      },
      AssinadoComSucesso: {
        message: "signed successfully"
      },
      FinalizadoComSucesso: {
        "message": "Document concluded."
      },
      AlgoErradoAconteceu: {
        message:'Something went wrong'
      },
      SenhasNaoBatem:{
        message:'passwords dont match'
      },
      CodigoNaoEncontrado:{
        message:'Code not found.'
      },
      SemCodigo:{
        message:'No code'
      },
      Senha:{
        message:'Password',
        newPassword: 'New password',
        typeYourPassword: "Enter your password...",
        typeYourPasswordAgain: "Enter your password again...",
        newPasswordRequirements: "The password must have at least 6 characters, with an uppercase letter, a special character and a number."
      },
      ConfirmarSenha:{
        message:'Confirm new password'
      },
      Enviar:{
        message:'Send'
      },
      Confirmar:{
        message:'Confirm'
      },
      IrParaLogin:{
        message:'Go to Login',
        message2: 'Go to Login'
      },
      Entrar:{
        message:'Get in',
        forgotPassword:'Forgot password',
        codPage:"Go to e-mail code page",
        characterMinimun: "Minimum characters",
        specialcharacters: "Special character",
        oneNumber: "One number",
        capitalLetter: "capital letter",
        registrar: "Register"
      },
      InsiraEmail:{
        message:'Enter your registered email'
      },
      InsiraSenha:{
        message:'Enter your registered password'
      },
      Code:{
        message:'Code',
        acepted:'Code accepted',
        header:'E-mail code'
      },
      AccessCode: {
        message: 'Access by code',
        label: 'Access Code',
        info: 'Have you received an access code to access the platform? Enter this code in the field below.'
      },
      LembrarDeMim:{
        message:'Remember me'
      },
      EsqueceuSenha:{
        message:'Forgot your password?'
      },
      UsuarioOuSenhaIncorretors:{
        message:'Incorrect username or password'
      },
      UsuarioOuCodeIncorretors:{
        message:'Incorrect username or code'
      },
      DoitLogin:{
        message:'Do it Login',
        sucess:"Accepted code"
      },
      Upload:{
        done:'Finalizado',
        error:'Ocorreu um erro',
        file:"File",
        folder: "Upload Folder",
        newFolder:"Folder",
        permission:"Permission",
        permissionGroup:"Groups Permission",
        permissionUser:"Users Permission",
        notEnoughStorage: "Not enough storage"
      },
      NotFound:{
        message: "Not found"
      },
      Datadamodificacao:{
        message:"Created"
      },
      Modificadopor:{
        message:"Modified by"
      },
      Tamanhodoarquivo:{
        message:"Size"
      },
      Folder:{
        save:"Saved with success",
        toSave:"Change"
      },
      DownloadFileError:{
        message:"Error on Download"
      },
      ReleaseError:{
        message:"Error on Set Release"
      },
      DraftError:{
        message:"Erro on Set Draft"
      },
      ArcinvingError:{
        message:"Error on Set Archiving"
      },
      SucessMove:{
        message:"File moved successfully!",
        error:"File donsn't moved!"
      },
      Start:{
        message:"Start"
      },
      Action:{
        message:"Action",
        send:"Send to Validation Rule"
      },
      ErrorMove:{
        message:"Error moving!"
      },
      Revisao:{
        term:"Revision",
        tracker:"Activity Tracker",
        time:"Time",
        ipUser:"Ip",
        name:"User's name",
        message:"Message",
        noEntries:"Sem Entradas"
      },
      DownloadSuccess:{
        message:"Downloaded successfully!"
      },
      DraftDate:{
        message:"Creation date"
      },
      Atualizar:{
        message:"Refresh"
      },
      Description:{
        message:"Description"
      },
      CertezaExcluirDocumentType:{
        message:'Are you sure you want to delete this document type?'
      },
      DocumenType:{
        deleteSucess:"Deleted documet type",
      },
      New:{
        female:"New",
        male:"New"
      },
      ValidationRules:{
        NewActivity:"New Activity",
        Deleted:"Are you sure you want to delete this validation rule?",
        DeletedOk:"Validation Rule deleted",
        RemovedOK:"Validation Rule removed"
      },
      Select:{
        message:"Select",
        error:"Error on find parameters"
      },
      Responsible:{
        message:"Responsible",
        select:"Select Responsible",
        suggestions:"Suggested Responsible",
        notFound:"No responsible found",
        lessOne:"Minimun one responsible"
      },
      ActivityName:{
        message:"Activity Name"
      },
      Pendencias:{
        message: "Pending",
        text: "Manage your documents: track the status of pending items, approvals, and rejections in a simple and efficient way."
      }, 
      CertezaExcluirPermission:{
        message:'Are you sure you want to delete this permission?'
      },
      Label:{
        Back:"GoBack Label",
        Forward:"GoForward Label"
      },
      CPF:{
        choice:'D4 Sign',
        invalid:'Invalid CPF',
        nextStep:'Validate',
        SaveInServer:'Save in server'
      },
      foreign:{
        message:'Foreign'
      },
      loadMore:{
        text:"Load more",
        error:"No more validarion rules found"
      },
      Exibir:{
        message:"View"
      },
      UsuarioSalvo:{
        message:"Saved User"
      }, 
      Copy:{
        message:'Successfully copied!',
        error:'Error copying!'
      },
      Wait:{
        message:"Wait"
      },
      ErroMail:"Invalid e-mail",
      SharedFile:{
        Error:"Error on consult",
        Menu:"Share file",
        FileDontShared:"File don't shared",
        ToShare:"To Share",
        AddEmail:"Add e-mail",
        EndedByDay:"Share until",
        EndedByAcces:"Share until usses acces x times",
        WithoutEnded:"Don't expire",
        ErroOnDelete:"There was an error deleting",
        ErroOnSave:"There was an error saving",
        NotCheckBox:"It is necessary to check a checkbox",
        ListEmails: "List must have emails",
        HasWatermark: "Share with watermark"
      },
      TextField:{
        TooltipTitle: "Click the button to add email."
      },
      permissionDriveOrg:{
        message:"Assign permission to drive",
        permission:"Drive permission"
      },
      renameItem:{
        message:"Rename ",
        error:"Error to rename"
      },
      editItem:{
        message:"Edit "
      },
      owner:{
        message:"Folder owner"
      },
      permissionFolder:{
        message:"Permissions"
      },
      Visualizador:{
        message:"Viewer"
      },
      PermicoesItem:{
        message:"Item permissions",
      },
      Move:{
        moveBy: "Mover to",
        message:"Move ",
        to:" to ",
        toRoot:"Move to root",
        root:" to root",
      },
      AcaoExecutada:{
        message:"Action Execute"
      },
      RevisaoDocument:{
        message:"Document Review"
      },
      Usuario:{
        message:"User"
      },
      DateAction:{
        message:"Action date"
      },
      ErrorDate:{
        Begin:"The start date cannot be greater than the end date.",
        End:"The end date cannot be less than the start date."
      }, 
      Arquivar:{
        message:"Archiving"
      },
      ResetPasswordRequest:{
        message:"Redefine password"
      },
      InvalidEmail:{
        message:"Invalid email"
      },
      EmailSent:{
        message:"Email sent"
      },
      NewResp:{
        message:"Select new responsible",
      },
      ArqResp:{
        message:"Files for which the user is responsible.",
      },
      SelectResp:{
        message:"Select the new user for the validation rule.",
      },
      Organizador:{
        message:"Organizer",
      },
      Common:{
        message:"Common",
        Guest: "Guest"
      },
    CalendarLabel:{
        message: "Expiration",
        toolTipMessage:"Expiration defines the validity period of a document.",
        From: "From:",
        To: "To:"
      },
      CalendarButtonToday:{
        TodayButton:"Today",
      },
      ReturnEmptyTracker:{
        MessageSnack:"Tracker not found",
      },
      NameExist:{
        message:"Name already exists"
      },
      Rejeitado:{
        message:"Successfully rejected!"
      },
      StroageInformation:{
        bookcase:"Bookcase",
        shelf:"Shelf",
        position:"Position / Box",
        menu:"Physical Location",
        additionalInformation: "Additional information"
      },
      Delete:{
        message:"Delete",
      },
      SelectValidationRule:{
        message:"Select the Validation rule",
      },
      ValidationRuleCanceled:{
        message:"Validation rule canceled!"
      },
    Remove: {
      message: "Remove"
    },
    NotificationEmail: {
      message: "Receive e-mail notification"
    },
      EditFolder: {
        title: "Edit Folder",
        information: "Information",
        folderName: "Folder name",
        sensitivity: "Sensitivity",
        owner: "Owner",
        notifications: "Notifications",
        updateInformation: "Update information",
        receiveEmailNotifications: "Receive email notifications."
      },
    ActionsInBatch: {
      message: "Actions in batch"
    },
    FilesWentToRelease: {
      message: "Files went to Release"
    },
    ErrorWhenUpdatingToRelease: {
      message: "Error when updating to release"
    },
    FilesWentToDraft: {
      message: "Files went to Draft"
    },
    ErrorWhenUpdatingToDraft: {
      message: "Error when updating to Draft"
    },
    UploadAsRelease: {
      message: "Upload as Release"
    },
    OrganizerCannotDelete: {
      message: "Organizer cannot delete"
    },
    EditorCannotDelete: {
      message: "Editor does not delete"
    },
    EditorCannotSeeRevision: {
      message: "Editor can't see revision"
    },
      WorkspaceAlwaysWithWaterMark: {
        message:"Always share with water mark."
      },
      WorkspaceAlwaysWithWaterMarkWarning: {
        message:"Workspace always with watermark option is setted."
      },
      FolderWithHighSensitivitySharedWarning: {
        message:"Files shared in high-sensitivity folders will always be watermarked"
      },
      Undo:{
        message:"Undo"
      },
      ConfirmTheDiscardOfTheDraft:{
        message:"This action is irreversible! Confirm the discard of the Draft?"
      },
      Term: {
        message:"Due Date",
        select:"Select Term",
        days:"Days",
        addTerm:"Add deadline type",
        current: "Limite date",
        on: "positive term",
        out: "deadline expired",
        noDeadline: "No deadline"
      },
      FileDownload: {
        message:"File download"
      },
      NoViewerModal: {
        title: "Unable to view this file",
        content: "The file you are trying to preview does not have a preview for reading.To be able to view it, click the button below to download and access the file."
      },
      informationModal:{
        message:"Information to whom the Validation was sent"
      },
      termRule:{
        message:"Choose a deadline for the validation rule.",
        select:"Select Term"
      },
      tag:{
        editMessage:"Successfully edited tag!",
        addMessage:"Tag successfully added!",
        errorEdit:"Error editing tag!",
        errorAdd:"Error adding tag!",
        notFound:"Tags not found",
        new:"New Tag",
        suggested:"Suggested Tags",
        edit:"Edit Tags",
        add:"Add Tags",
        insertMessage:"Insert tags in files and folders for easy access and easily find what you're looking for.",
        LoadingResults:"Loading more results...",
        save:"Save Information",
        cancel:"Cancel",
        nameFile:"File name",
        descFile:"File description",
        semDesc:"Without description",
        fileTag:"File tags",
        tagExist:"The name already exists",
        messageTag:"Tag already exists",
        NoTag: "No tags"
      },
      validationRulePanel: {
        select: "Select the validation rule that matches the current need for the document.",
        execution: "Execution",
        selectUser: "Select the person responsible who will execute the validation rule selected above.",
        alreadySetConfig: "Settings already allocated in the validation rule.",
        alreadySetValidation: 'Validation"s settings already been allocated. Click "Send to responsible" to complete.',
        sendToResponsible: "Send to responsible.",
        OkUnderstand: "Ok, I understand",
        validationRuleSubmit: "Validation Rule successfully submitted.",
        validationRuleData: "The validation rule has been sent to the person responsible who matches the data listed below.",
        responsible: "Responsible",
        withTerm: "No term.",
        emailWrong: "The item that was pending was completed successfully. You can disregard the received email and close this window.",
        responsableError: "Responsable must be set.",
        norVrFounded: "No validation rule found.",
        title: "Validation rule",
        termError: "A deadline must be set."
      },
      substituir:{
        message:"Replace"
      },
      DetailDocumentPage: {
        Actions: "Actions",
        Save: "Save",
        Description: "No description...",
        ModDate: "Date modified",
        ModResp: "Document Manager",
        Term: "Term",
        NoTerm: "No Term...",
        Visualization: "Visualization",
        ActivityTracker: "Activity tracker",
        Location: "Physical Location",
        Reviews: "Reviews"
      },
      WhatAreYouLookingFor: {
        message: "What are you looking for..."
      },
      Wizard: {
        organization: "Organization",
        password: "Password",
        confirmPassword: "Confirm your password",
        welcome: "Welcome!",
        return: "Back",
        continue: "Continue",
        conclude: "Conclude Register",
        name: "Name",
        addUsers: "Add",
        errorUsers: "Numbers of users invalid",
        emailInfo:"Add up to 5 employees to be part of the company's work environment",
        descriptionEnd:"Verify if the informations are correct. If is, click in \"",
        descriptionEndBold:"Conclude Register",
        descriptionEndSecond:"\".",
        maxUserlength: "Max users exceeded",
        fillAllFields: "Fill all fields correctly",
        emailAlreadyInList: "E-mail already on list."
      },
      Login: {
        forgotPass: "Forgot my password",
        password: "Password",
        goToEmailPage: "Go to e-mail page",
        accessAcount: "Enter your account",
        helloAgain: "Hello, Again! Fill the text fields with your data to access your account.",
        putYourNewPass: "Put your new password.",
        fillTheFieldsDown: "Fill the fields down with your new password.",
        forgotYourPass: "Forgot your password?",
        fillTheEmailRegistered: "Fill the text field down with your registered e-mail to recover your password.",
        typeYourEmail: "Type your e-mail...",
        typeYourPassword: "Type your password...",
        accessWithCode: "Access with code.",
        doYouReceived: "Do you received the access's code to enter the application? Insert your code in text field down.",
        yourAccessCode: "Access's code.",
        typeYourAccessCode: "Type your access's code...",
        privacyPolicy: "Privacy policy",
        allRights: "All rights reverved.",
        checkYourEmail: "Check your e-mail.",
        confirmationEmail: "If your e-mail is valid, a link was sended to change your password.",
        didntRecieved: "Didn't you recieve your e-mail?",
        clickHereToResend: "Click here to resend",
        alrightUnderstand: "Alright, understand.",
        qrcodeTitle: "QR code generated",
        qrcodeSub: "Scan the qrcode bellow to configure your application.",
        otpTittle: "One time password",
        otpSub: "Put the code that you got in your authenticator.",
        OtpMessage: "One time password",
        qrcodeRedirect: "Afer you scan the qrcode, you must click in the button bellow to insert your one time password.",
        oneUsePassword: "Put a one use password.",
        otpErrorMessage: "One time password must be defined",
        error: "Login problem",
        oneTimePasswordError: "Your one-time password was not accepted, please try again.",
        oneTimePasswordSucess: "Your one-time password was successfully accepted.",
        microsoft: "Continue with",
        confirm: "Confirm"
      },
      InvalidCaptcha:{
        message:"Invalid captcha"
      },
      ResetPasswordSuccess: {
        title: "Password changed successfully",
        subtitle: "Your password has been changed successfully, remember to keep it under lock and key. Click the button below to access login."
      },
      Reset:{
        message:"Reset successfully."
      },
      AutoArquivar:{
        message:"Auto Archive"
      },
      ParaArquivar:{
        message:"To file"
      },
      Temporality:{
        message:"Temporality",
        subtitle: "Track deadlines and statuses clearly, analyzing time-based progress for better management and decision-making.",
        panelTitle:"Add Temporality",
        dateTemp:"Auto Archive in:",
        select: "Select Temporality",
        descriptionTemporalityMenu: "Select one of the workspaces below to view the temporality report.",
        Expired: "Expired",
        Filed: "Filed",
        Signed:"Signed",
        Removed: "Removed"
    },
    TemporalityComboBox: {
      ExplanatoryText: "Change status to",
      TooltipHostDefalt: "The status defines the state, positioning or situation of the document in the process in which it is found.",
      TooltipHostExpired: 'The "Expired" status will define that the deadline has passed to perform some action related to the selected document.',
      TooltipHostArquived: 'The "Archived" status will save and inactivate the document. It can be active and resumed again at any time.',
      TooltipHostDraft: 'The "Draft" status is defined as draft, that is, the item will be in an initial state and will need to undergo a new validation.',
      PlaceHolder: "Select"
    },
    dataArqchive: {
      message: "Archiving Date"
    },
    WithoutRule: {
      withoutRule: "Without rule.",
      withoutDesc: "No description"
    },
    ViwerInfo: {
      cannotView: "Cannot view this file",
      notPreview: "The file you are trying to view has no preview to read. To be able to view it, click the button below to download and access the file.",
      downloadFile: "Download the file.",
      successfullyDownload: "Successfully download."
    },
    DataTableHeaders: {
      Reviews: "Reviews",
      Actions: "Actions",
      Users: "Users",
      Date: "Creation date",
      Name: "Name",
      Description: "Description",
      ExplanatoryText: "Date the action will be executed",
      TooltipHost: "Expiration defines the validity period of a document."
    },
    FilterTables: {
      OrdenationDate: "Order By Date",
      Reviews: "Reviews",
      AlphaOrder: "Alphabetical order",
      OrderByUsers: "Order by users",
      OrderByMessages: "Order by messages",
      Descending: "Descending",
      Ascending: "Ascending",
      apply: "Apply",
      clearFilters: "Clear filters"
    },
    DetailPhLocation: {
      TypeHereLocal: "Enter here... (e.g., Room, Building, Floor)",
      TypeHereBookcase: "Enter here... (e.g., Green bookcase, Bookcase no. 3)",
      TypeHereShelf: "Enter here... (e.g., Shelf no. 3, Fourth shelf from top to bottom)",
      TypeHerePosition: "Enter here... (e.g., Red box, File on top of the table)",
      TypeHereAdditionalInformation: 'Enter here...',
      SaveButton: "Save changes",
      CancelButton: "Cancel changes"
    },
    UnableToReturnItemTemporality: {
      message: "Unable to return Item Temporality"
    },
    SelectTemporality: {
      message: "Select Temporality"
    },
    SelectDocumentExpiration: {
      message: "Select document expiration"
    },
    DocumentValidity: {
      message: "Document validity"
    },
    Validity: {
      message: "Validity"
    },
    EmptyTemporalityField: {
      message: 'Empty temporality field'
    },
    EmptyDocumentValidityField: {
      message: 'Empty document validity field'
    },
    RetroactiveDueDate: {
      message: 'Retroactive due date'
    },
    HasExpired: {
      message: 'Has expired'
    },
    Option: {
      message: "Set status to"
    },
    RemoveTemporality: {
      message: "Remove temporality"
    },
    Reload: {
      message: "Reload"
    },
    AssignServiceUser: {
      message: "Assign service user"
    },
    ErrorReceivingAdminUsers: {
      message: "Error receiving admin users"
    },
    Dashboard: {
      general: "General",
      storageLimit: "Your storage limit is",
      generalDataUsage: "General data usage",
      storageInUse: "Storage in use",
      freeStorage: "Free storage",
      wsDataUsage: "Data usage in workspaces",
      storageUseWithoutContract: "No max storage set",
      OrganizationDoesntHaveWorkspace: "Organization Doesn't have any workspace.",
      storagePerUser: "Storage per user",
      notFoundgeneralData: "General data not available at the moment.",
      AllUsers: "All users",
      Users: "Users",
    },
    UpgradeCard: {
      needUpgrade: "Need an ",
      upgradeSpace: "space upgrade?", 
      wantUpgrade: "I want an upgrade"
    },
    StorageTypeFile: {
      documents: "Documents",
      imagens: "Images",
      videos: "Videos",
      others: "Others"
    },
    FilterRangeUsageStorage: {
      buttonFilter: "Filter",
      title: "Storage Usage",
      greaterThan: "Greater than",
      lessThan: "Less than",
      clear: "Clear",
      apply: "Apply",
      valueCannotBeNegative: "Value cannot be negative."
    },
    Dwg: {
      size: "Size",
      palette: "Palette",
      orientation: "Orientation",
      converterType: "Converter type",
      backgroundColor: "Background color",
      title: "Select the options below to view the file"
    },
    Selecionar: {
      message: "Select"
    },
    YourBrowserDoesNotSupportThePrintingFunction: {
      message: "Your browser does not support the printing function."
    },
    ChooseColumns: {
      message: 'Filter by',
      description: 'Description',
      validationRule: 'Validation rule',
      term: 'Term',
      size: 'Size',
      createdAt: 'Created at',
      applyFilter: "Apply filter",
      reset: "Reset"
    },
    FilterBy: {
      message: "Filter by status",
      toolTipMessage: "The status defines the state, positioning or situation of the document in the process in which it is found.",
      placeholderMessage: "Select..."
    },
      NoRegistry: {
        title:"No filters selected",
        message: "Select an expiration date and a status to perform your search.",
      },
      WorkspaceItemFlowListing:{
        responsible: "Responsible",
        date: "Date",
        progress: "In progress",
        waiting: "Waiting...",
        by: "By",
        dynamic: "Dynamic responsable"
      },
      OrganizationMessages: {
        "problemWithResources": "We've some troubles to get back your resources.",
        "resourceAlert": "Contract doesn't have the api call resource."
      },
      ErrorViwer:{
        title:"It was not possible view this file",
        description:"An unexpected error occurred while trying to view. Try viewing the file again."
      },
      ViwerAutomaticDwg:{
        message:"Generate cad visualization data in the background."
      },
      DuplicateFolder: {
        message:"Duplicate folder"
      },
      NameMustNotIncludeEitherSlashes: {
        message: "Name must not include either \ or /"
      },
      MaintainPermissions: {
        message:"Maintain permissions"
      },
      DuplicationOf: {
        message:"Duplication of"
      },
      CopyDocumentLink: {
        message:"Copy document link",
      },
      ItemIdNotFound: {
        message: "Item id not found",
      },
      WithoutPermission: {
        message: "Without permission",
      },
      RecicleBin: {
        title: "Recycle Bin",
        subtitle: "Stay in control: Restore or permanently delete files from the trash.",
        fileName: "File Name",
        userName: "Responsible",
        date: "Deletion Date",
        confirm: "Confirm",
        restore: "Restore",
        to: "to",
        search: "Search...",
        folder: "Folder",
        fileRestored: "File restored",
        goToFileFolder: "Go to file folder",
        finishAndClose: "Finish and close",
        deletedSuccessTitle: "Removal successfully completed!",
        deletedSuccessHeader: "Check below the items that were permanently deleted.",
        emptyRecycleBinPartA: "Recycle bin empty",
        emptyRecycleBinPartB: "It looks like someone finally took out the trash.",
        emptyRecycleBinPartC: "There are no files or folders here.",
        emptyRecycleBinPartD:"There are no folders here",
        selectOneWorkspace:"Select a Workspace to view folders.",
        deleteConfirm: "Confirm if you really want to permanently remove the file",
        deleteConfirmTwo: "Once removed, it cannot be recovered.",
        deleteTitleList: "Do you want to remove all items?",
        deleteConfirmList: "Confirm if you really want to permanently remove all the items listed below. Once removed, they cannot be recovered.",
        cancel: "Cancel",
        deleteSelected: "Remove files",
        restoreListButton: "Restore files",
        restoreTitleConfirm: "Do you want to restore the file?",
        restoreTitleConfirmList: "Restore all items?",
        restoreConfirmList: "Confirm if you really want to restore all the items listed below. Finally, define the storage destination.",
        deleteModalTitle: "Do you want to remove the file?",
        headerRestorePartA: "To restore the file",
        headerRestorePartB: "define the storage destination.",
        headerRestoreLastConfirmation: 'Check the restoration information below and confirm if the restoration path is correct. If incorrect, click "Cancel".',
        headerRestoreSuccessTitle: "File successfully restored!",
        headerRestoreSuccessPartA: "The file",
        headerRestoreSuccessPartB: "was successfully restored. Check below the",
        headerRestoreSuccessPartC: "information to find it after restoration.",
        removedBy: "Removed by",
        
        filter: "Filters",
        files: "Files",
        select: "Select...",
        viewMyFiles: "View my files",
        seeAllFiles: "View all files",
        current: "(Current)",
        defalt: "(Default)",
        reset: "Reset",
        applyFilter: "Apply filter",

        compareFiles: "Compare files",
        ignoreFiles: "Ignore files",
        replaceFiles: "Replace files",
        compareFile: "Compare file",
        ignoreFile: "Ignore file",
        replaceFile: "Replace file",
        CheckItemsSameNameTitle: "There are already items with the same name at the destination",
        headerCheckItemsSameNamePartA: "The destination already contains ",
        headerCheckItemsSameNamePartB: " items/files",
        headerCheckItemsSameNamePartC: " with the same names. Select",
        headerCheckItemsSameNamePartD: " below which action you would like to take.",

        compareFilesTitle: "Compare the files and choose one of them",
        headerCompareFiles: "Compare the files below to decide which version you want to keep.",
        compareFilesTitleList: "Item in",

        restoreSuccessListTitleType1: "Replacement and restoration completed successfully!",
        restoreSuccessListTitleType2: "Files ignored and restoration completed successfully!",
        restoreSuccessListTitleType3: "Items updated successfully!",
        headerRestoreSuccessListType1PartA: "The replacement and restoration of the items were successfully completed. See",
        headerRestoreSuccessListType1PartB: " below the list of restored files and folders.",
        headerRestoreSuccessListType2PartA: "The restoration was completed. Files with duplicate names were",
        headerRestoreSuccessListType2PartB: "ignored. See below the list of restored files and folders.",
        headerRestoreSuccessListType3PartA: "The selected items were successfully updated. Check below the list",
        headerRestoreSuccessListType3PartB: "with the updated items.",

        selectedListTooltipText: "Open in new tab",
        deleteConfirmTooltipText: "Permanently delete file",
        restoreConfirmTooltipText: "Restore file from trash"
      },
      NotFoundPage:{
        header: "Page not found",
        body: "Unfortunately the page you tried to access was not found.",
        button: "Return to Home",
      },
      LoggedHome: {
        QuickAccessContent: "Save your frequently used paths and files and access them quickly from here or wherever you are.",
        QuickAccessTitle: "Quick Access",
        OrganizationsContent: 'The most visited or favorited workspaces are available right below. To view all, click on "Workspace".',
        OrganizationsTitle: "Organizations",
        RecentActivities: "Recent Activities",
        RecentActivitiesContent: 'Access recently performed activities. To view all, click on "Updates".',
        FileName: "File name",
        Action: "Action",
        Responsible: "Responsible",
        LastModification: "Last modification",
        favoriteSuccess: "successfully favorited.",
        favoriteExclude: "Favorite item deleted.",
        favoriteError: "favorite already exists.",
        NoRecentActivities: "No recent activities",
        MovingOrganization: "Start moving your organization through workspaces. This way, you will be able to view activities here",
        ViewMore: "View full list"
      },
      Minicard: {
        File: "File",
        Folder: "Folder",
        Desfav: "Unfavorite",
        fav: "Favorite",
        NothingViewMiniCardTitle: "No saved itens",
        NothingViewMiniCardContent: "No items have been saved yet.",
        NothingViewMiniCardWorkspaceTitle: "No saved workspace.",
        NothingViewMiniCardWorkspaceContent: "No saved have been saved yet.",
        NothingViewMiniCardWorkspaceTitleAdm: "No saved workspace.",
        MiniCardAllFavoritesTitle: "All workspaces was favorited.",
        MiniCardAllFavoritesContent: "All your workspaces are in favorited section",
        NothingViewMiniCardWorkspaceContentAdm: "As an admin, you can create a workspace by clicking here!"

      },
      LogErrors: {
        browser: "Browser",
        errorFound: "Error Found",
        createdDate: "Created Date",
        server: "Server",
        method: "Method",
        stackTrace: "Stack Trace",
        userMail: "User Email",
        line: "Line",
        search: "Search..."
      },
      FileNotFound: {
        message: "File not found"
      },
      Divider: {
        message: "or"
      },
      Navbar: {
        placeholderImputText: "What are you looking for...",
        labelCheckbox: "Only in this folder"
      },
      ShareFileComp: {
        share: "Share",
        firstTitle: "To share the item below with other users, please fill in the fields according to the sharing requirements.",
        advancedOptions: "Advanced Options",
        hasWatermark: "Contains Watermark",
        sharetilDate: "Share Until Date",
        limitAccess: "Limit Access Count",
        dontLimitAccess: "Share Without Expiring Access",
        shareWith: "Share With",
        back: "Back",
        textWord: "Text (Word)",
        orientation: "Orientation",
        SaveWatermark: "Save Watermark",
        editWatermark: "Edit Watermark",
        shareSuccess: "File sharing completed successfully.",
        typeHere: "Type Here...",
        text: "Text",
        noWatermark: "No Watermark"
      },
      Snackbar: {
        success: "Success!",
        Atention: "Atention!",
        Error: "Error!",
        Information: "Information!"
      },
      Drag: {
        NotPossible: "Dragging items is not allowed while editing."
      },
    Sidebar: {
      QuickAccess: "Quick access",
      Home: "Home",
      Dashboard: "Dashboard",
      Feed: "Updates",
      Groups: "Groups",
      Pendencies: "Pendencies",
      Users: "Users",
      Documents: "Documents",
      ValidationRules: "Validation Rules",
      Temporality: "Temporality",
      Preferences: "Preferences",
      CloseSidebar: "Close sidebar",
      Organizations: "Organizations",
      Privileges: "Privileges"
    },
    MigrationsTab: {
      Migrations: "Migrations", 
      NotMigrationsPending: "There are no pending migrations", 
      MigrationsPendingContent: "When there are pending migrations, they will appear here.", 
      UserEmail: "Name user",
      IdSubscription: "Subscription ID", 
      Actions: "Actions", 
      NameUser: "Username",
      AceptMigration: "Acept Migration",
      DeclineMigration: "Decline Migration",

    },
    PlanCheckout: {
      PlanCheckoutContent: "Your plan has been activated on your account. To access it, return to the login page and fill in the fields with the registered information.", 
      PlanCheckoutTitle: "Plan successfully activated!" 
    },
    Register: {
      NullOrg: "Organization name cannot be empty",
      OrgName: "Organization name",
      PassNull: "Passwords cannot be empty",
      Password: "Password",
      ConfirmPassword: "Confirm Password",
      TypeHere: "Type here...",
      Minimun8: "At least eight letters",
      AnUpperCaseLetter: "An uppercase letter",
      ASpecialLetter: "A special letter",
      Numeric: "A numeric letter",
      PasswordMatch: "Passwords match",
      FirstPageError: "Text fields cannot be empty",
      Username: "Username",
      Email: "E-mail",
      WantSendingEmail: "I want to receive emails with important updates and platform notices.",
      IamOkPrivacy: "I agree with the Terms of Service and Privacy Policy",
      BackToLogin: "Back to login",
      AlreadyHaveAccount: "Already have an account? ",
      BeOkWithBoth: "You need to agree to our policies and to receiving emails."
    },
    AdminConsole: {
      GuestUserTitle: "User will be added as guest",
      GuestUserContent: "The user you intend to add already has an active subscription, they will be added to your organization as a guest user.",
      Hello: "Hello,",
      later: "Decide later",
      TestUser: " Test User!",
      Migrations: "Migrations",
      User: "User",
      HereYouHaveAccessToYour: "Here you have access to your",
      AdminPanel: " admin panel,",
      YouWillFindAllTheToolsYouNeedToManageYourSubscription: " you will find all the tools you need to manage your subscription.",
      AccountAndSubscription: "Account and Subscription",
      ManageYourAccountAndSubscriptionEnsuringFullControlOverImportantSettings: "Manage your account and subscription, ensuring full control over important settings.",
      FollowRealTimeUpdatesAndNotificationsToStayInformedAboutImportantActivities: "Follow real-time updates and notifications to stay informed about important activities.",
      UsersAndGroups: "Users and Groups",
      EfficientlyLearnAboutUsersAndGroupsToFacilitateCollaborationAccessControlAndPermissions: "Efficiently learn about users and groups to facilitate collaboration, access control, and permissions.",
      CheckOutAndManageOrganizationsViewingDetailsLikeStorageAndSettings: "Check out and manage organizations, viewing details like storage and settings.",
      SEEMORE: "SEE MORE",
      ReturnToAccount: "Return to Account",
      NeedToTalkToSupport: "Need to talk to support?",
      ContactOurSupportTeamByClickingTheButtonBelow: "Contact our support team by clicking the button below.",
      GetInContact: "Get in contact",
      Users: "Users",
      Groups: "Groups",
      Privileges: "Privileges",
      Privilege: "Privilege",
      WhatAreYouLookingFor: "What are you looking for...",
      NewUser: "New user",
      NewGroup: "New group",
      GuestUserAdd: "New guest",
      GuestUserSnackMessage: "Guest user added successfully!",
      Name: "Name",
      GroupName: "Group name",
      Phone: "Phone",
      Participants: "Participants",
      EditInfo: "Edit informations",
      Save: "Save",
      Cancel: "Cancel",
      Back: "Back",
      UsersInfo: "Users informations",
      GroupsInfo: "Groups informations",
      AvailableGroups: "Available groups",
      LoginWithTwoFa: "Login with two factor authentication",
      EnableTwoFa: "Enable this option to allow the user to log in to the system using two-factor authentication.",
      AllowTwoFa: "Allow login with two-factor authentication.",
      TypeUserName: "Enter the user's name here...",
      Select: "Select...",
      TypeUserEmail: "Enter the user's e-mail here...",
      TypeUserPhone: "Enter the user's phone here...",
      TypeGroupName: "Enter the group's name here...",
      AddUser: "Add user",
      NoUsers: "No users added",
      Owner: "Owner",
      Administrators: "Administrators",
      AddUsersToGroup: "Fill in the field above and add users to the group.",
      UsersMin: "users",
      GroupsMin: "groups",
      Showing: "Showing",
      Total: "overall",
      Of: "of",
      MeAnd: "@Me and",
      UsersParticipates: "Users participates",
      InvalidUsername: "Enter at least 3 digits.",
      InvalidEmail: "The email entered is not valid.",
      InvalidPhone: "Enter 11 digits or none",
      DisableGroupModalTitle: "Do you want to delete the group?",
      DialogDeleteGroupStart: "Confirm that you would really like to permanently delete the",
      DialogDeleteGroupEnd: "group. Once removed, it will not be possible to recover it.",
      UserRemovedFromGroup: "User removed from group",
      DisableGroup: "Disable group",
      GroupCreated: "Group created successfully",
      Organizer: "Organizer",
      Validator: "Validator",
      Reader: "Reader",
      RootSubtitle: "You have full access to all system functionalities, including creating and managing folders and documents, among other options.",
      OwnerSubtitle: "Allows you to make edits to the tool and access its features. However, you cannot create or delete folder structures.",
      OrganizerSubtitle: "It does not have access to administrative privileges and cannot change the root folder, but it can create new subfolders and documents, as well as edit and delete existing content. Subfolders will automatically inherit the same privileges as groups and users in the root folder.",
      EditorSubtitle: "Make edits in the tool and have access to the features. You cannot create and delete folder structures.",
      ValidatorSubtitle: "Allows you to consult, view and download documents. It also offers features for approving and signing documents.",
      ReaderSubtitle: "These users only consult and view documents in permitted Workspaces.",
      ResetPasswordEmail: "Password reset email sent",
      RemoveGroup: "Remove from group",
      DisableUser: "Disable user",
      EditUserInfo: "Edit informations",
      ResetPassword: "Reset password",
      DoesNotHave: "Does not have",
      WorkspaceSubtittle: "Here you can view all existing Workspaces in this Organization.",
      NewWorkspace: "New workspace",
      NotFoundWorkspace: "No Workspaces yet",
      NoFoundWorkspaceSubtittle: "Join or create a workspace and then the workspace will appear available here.",
      NoDescription: "No description",
      UsersWithAccess: "Users with access",
      Documents: "Documents",
      NewWorkspaceTitle: "New Workspace",
      UpdateWorkspaceTitle: "Update Workspace",
      CreateWorkspace: "Create Workspace",
      UpdateWorkspace: "Update Workspace",
      CreatingYourWorkspace: "We're creating your workspace. Wait a moment.",
      UpdateYourWorkspace: "We're updating your workspace. Wait a moment.",
      CreatingWorkspace: "Creating workspace",
      UpdatingWorkspace: "Updating workspace",
      CreatingYourWorkspaceDialog: 'Workspace has been created successfully! Click "Continue" to view the list of Workspaces and access them.',
      UpdateYourWorkspaceDialog: 'Workspace has been updated successfully! Click "Continue" to view the list of Workspaces and access them.',
      CreatingYourWorkspaceDialogTitle: 'All set',
      CancelSubscriptionDialogTitle: 'Are you sure you want to cancel your subscription?',
      Duplicate: "Clone",
      Edit: "Edit",
      Favorite: "Favorite",
      Unfavorite: "Unfavorite",
      Delete: "Delete",
      Confirm: "Confirm",
      Continue: "Continue",
      DeleteDialogTextPart1: "Confirm that you would really like to permanently delete the ",
      DeleteDialogTextPart2: "Workspace. Once removed, it will not be possible to recover it.",
      DeleteDialogTitle: "Do you want to delete Workspace?",
      WorkspaceName: "Workspace name",
      ValidationWorkspaceName: "Name must have 3 or more characters",
      WorkspaceDescription: "Workspace description",
      Rules: "Rules",
      UploadAsRealease: "Upload as release",
      CadBackground: "Generate file preview data. CAD in the background",
      PrivilegeFollow: "Privileges at the root of the workspace will be inherited by the folders (including changes)",
      NoUsersInWorkspace: "No users in workspace",
      NoUsersInWorkspaceSub: "Fill in the field above and add users to the group.",
      TheWorkspaceDoesNotHaveAnyLinkedUsersYet: "The workspace does not have any linked users yet.",
      CommonUsers: "Common",
      ReadUsers: "Reader",
      EditUsers: "Editor",
      ViewUsers: "Viewer",
      OrganizeUsers: "Organizer",
      SeeAll: "See all",
      ClientInformation: "Client Information",
      Company: "Company",
      Responsible: "Responsible",
      ResponsiblePersonEmail: "Responsible Person's Email",
      CellPhone: "Cell Phone",
      ContractInformation: "Contract Information",
      ContractNumber: "Contract Number",
      TermOfTheContract: "Contract Term",
      TotalContractValue: "Total Contract Value",
      Organizations: "Organizations",
      Server: "Server",
      Plan: "Plan",
      Category: "Category",
      Storage: "Storage",
      LoginWithOffice365: "Login with Office 365",
      DescriptionLoginWithOffice365: "This option allows the user to log into the system using their Microsoft account.",
      AllowsLoginWithOffice365: "Allows login with Office 365",
      ContactOurSupportTeamByClickingTheButtonNextToIt: "Contact our support team by clicking the button next to it.",
      NoExistingContract: "No existing contract",
      DescriptionNoExistingContract: "It appears that no contract has been created yet.",
      Group: "Group",
      FreeTier: {
        FreeTitle: "You are using a free version of the system!",
        FreeContent: "Subscribe to one of our plans to gain access to the admin tabs.",
        AccessPlans: "View Plans"
      },
      ErrorContract: "There was an error involving the retrieval of your contract, and we are already resolving it. If the problem persists, please contact support.",
      ErroContractTitle: "There was an error",
      DashboardSubtitle: "Monitor essential data and metrics intuitively to optimize decisions and efficiently track performance.",
    },
    Security: 
    {
      AdminAccessDeniedTitle: "Restricted Access - Administrator",
      AdminAccessDeniedMessage: "For security reasons and compliance with the LGPD, system administrators do not have access to pages containing sensitive payment data and users' personal information. This restriction protects data privacy and ensures the principle of least privilege."
    },
    AccountAndSubscription: {
      RecoverySubscription: "Recover subscription",
      CanceledSubscriptionCaption: "Your subscription is canceled. For more details, contact support.",
      IdInvoice: "Invoice ID",
      Username: "Email",
      StatusInvoice: "Invoice status",
      CancelSubscription: "Cancel subscription",
      ClientServices: "Client services",
      Others: "Others",
      NoFeatures: "Non-existent features",
      SwitchServices: "I will switch service",
      AddCancelComments: "Add comments so we can improve our software. (field required)",
      RecoverySubscriptionDialogContent: "Recover your canceled subscription by clicking the recover button. Your subscribed items will be maintained and you will be able to use the software normally. (The SAME contracted plan will be recovered and billing will be automatic.)",
      CancelSubscriptionMotivate: "Why do you want to cancel your subscription?",
      Payment: "Payment",
      EditPaymentCard: "Edit credit card",
      Copy: "Copied",
      PaymentLinkGenerated: "Payment update link generated",
      ExpiresIn: "Expires in",
      CardNumber: "Card number",
      Plan: "Plan",
      Storage: "Storage",
      Users: "Users",
      ContractValue: "Value",
      SwitchPlansEveryMoment: "You can change your plan at any time",
      Category: "Category",
      AccountPlan: {
        Free: "Free",
      },
      LabelStepsPayments : {
        ValidatingData: "Validating data",
        CreatingPaymentMethod: "Creating payment method",
        UpdatingPaymentMethod: "Updating payment method",
        Finalizing: "Finalizing"
      },
      ProcessingNewPaymentMethod: "Processing your new payment method",
      PaymentMethodUpdatedSuccessfully: "Payment method updated successfully!",
      PaymentMethodUpdatedSuccessMessage: "Your payment method has been updated successfully. Thank you for continuing with KeyDrive.",
      ClickToLogoutAndRefresh: "Click to logout and refresh",
      TryAgain: "Try again",
      ErrorProcessingPaymentMethod: "Error processing your new payment method",
      WhatToDoNow: "What to do now?",
      CheckCardDetailsAndTryAgain: "Check your card details and try again",
      EnsureAllFieldsFilledCorrectly: "Make sure all fields are filled correctly",
      ContactSupportIfProblemPersists: "If the problem persists, contact support",
      CardDetails: "Card Details",
      BillingAddress: "Billing Address",
      WantToCancelNow: "I want to cancel now",
      Back: "Back",
      SubscriptionCancelledSuccessfully: "Your subscription has been cancelled successfully!",
      Confirm: "Confirm",
      CancelSubscriptionImmediatelyWarning: "By clicking the confirm button your subscription will be cancelled immediately, and you will lose access to paid features.",
      CancelSubscriptionRightNow: "Cancel subscription right now"
    },
    CancelDueAlert: {
      SubscriptionScheduledForCancellation: "Your subscription has been scheduled for cancellation on",
      CheckWithAdmin: "Please check with your administrator for the best way to proceed.",
      CanCancelRequest: "you can cancel this request by clicking the button next to it!",
      AccessAccountAndSubscription: "Access account and subscription"
    },
    Privileges: {
      ModifyUser: "Modify Privilege (User)",
      AddUser: "Add Privilege (User)",
      AddGroup: "Add Privilege (Group)",
      DefineNewPrivilege: "Define the user's new privilege according to one of the options below; Current privilege:",
      ModifyGroup: "Modify Privilege (Group)",
      DefineNewPrivilegeGroup: "Define the group's new privilege according to one of the options below; Current privilege:",
      VerifyUserPrivilegeCaption: "Check the users who have some privilege in",
      Item: "Item",
      Workspace: "Workspace",
      IsSubFolder: "This folder is a subfolder; it is not possible to modify privileges of subfolders.",
      Users: "Users",
      Groups: "Groups",
      Add: "Add",
      Edit: "Edit",
      DefineWithOptions: "Define the user's privilege according to one of the options below:",
      DefineWithOptionsGroup: "Define the group's privilege according to one of the options below:",
      Privileges: "Privileges",
      DefinePrivilege: "Define Privilege",
      Organizer: "Organizer",
      Reader: "Reader",
      Common: "Common",
      Editor: "Editor",
      None: "None",
      OrganizerBehavior: "Does not have access to administrative privileges and cannot change the root folder, but can create new subfolders and documents, as well as edit and delete existing content. Subfolders will automatically inherit the same privileges of the root folder’s groups and users.",
      ReaderBehavior: "Performs edits in the tool and has access to functionalities. Cannot create or delete folder structures.",
      EditorBehavior: "These users only consult and view documents in the allowed Workspaces.",
      CommonBehavior: "User who only belongs to the workspace, but has no privilege until someone grants it.",
      ExcludeTitle: "Do you really want to delete this permission?",
      ExcludeContent: "By deleting the permission, the user will be removed from the workspace and the folders they have permissions for.",
      Confirm: "Confirm",
      Cancel: "Cancel",
      Name: "Name",
      Email: "Email",
      Phone: "Phone",
      Privilege: "Privilege",
      Participants: "Users",
      Owner: "Owner",
      NoPrivileges: "No privileges assigned.",
      NoPrivilegesText: "Configure the necessary privileges for the user to access the system resources.",
      NoPrivilegesGroupText: "Configure the necessary privileges for the group to access system resources."
    },
    FileUploader: {
      UploadOfFiles: "File upload",
      Of: "of",
      FilesInProgress: "files in progress",
      TitleModalCloseUpload: "There are files being uploaded... Cancel anyway?",
      SubtitleModalCloseUpload: "It looks like there are files still being uploaded. Please confirm if you would like to close and cancel the uploads in progress.",
      TextButtonReject: "No! Keep uploading...",
      TextButtonAccept: "Yes, cancel uploads.",
      Waiting: "Please wait...",
      UploadStatus: {
        Success: "Upload successful",
        Error: "Upload failed",
        Canceled: "Upload canceled",
        Warning: "Upload warning",
        Others: "Unknown error"
      }
    },
    Feed: {
      Updates: "Updates",
      HeaderText: "Here, you will find all the news and changes related to the documents.",
      NonExistingUpdates: "Non-existent updates",
      NonExistingUpdatesText: "There appears to have been no movement so far. Please try again later.",
      NoContentWithFilter: "Unfortunately no updates were found for the applied filter. Please try again.",
      NoContentFound: "No updates found",
      AssignedTo: "Assigned to",
      ShowAll: "Show all (Default)",
      Term: "Term",
      Start: "Start",
      End: "End",
      Reset: "Reset",
      ApplyFilter: "Apply filter",
      Today: "Today",
      Yesterday: "Yesterday",
      PreviousUpdates: "Previous updates",
      SeeMore: "See more",
      Filters: "Filters",
    },
    Signture: {
      UnderSignture: "You are under a plan subscription",
      Guest: "Guest",
      SigntureCanceledContent: "You are using Keydrive with a canceled subscription. To continue using the system, please choose a new plan.",
      SigntureCanceledTitle: "Your subscription has been canceled",
      YourPaymentMethodNeedToBeUpdatedContent: "Your payment method failed. We ask that you update as soon as possible so you don't lose access to our system.",
      YourPaymentMethodNeedToBeUpdatedTitle: "Your payment method needs to be updated",
      SetupNewPaymentMethod: "Update payment method",
      UpdatePaymentMethodLater: "Update later",
      EditPaymentMethod: "Edit payment method"
    },
    MyData: {
        Mydata: "My data",
        Cancel: "Cancel",
        Save: "Save",
        PersonalizeExp: "Customize your experience by setting your profile picture, providing your details, and keeping your password secure and up to date.",
        UploadImageTerms: "Upload an image of at least 800x800px (recommended). Only .JPG or .PNG formats are accepted.",
        Userimage: "User image",
        PersonaInformation: "Personal information",
        Name: "Name",
        PhoneNumber: "Phone number/Cellphone",
        Pass: "Password",
        Login: "E-mail",
        CurrentPass: "Current Password",
        ChangePass: "Change password",
        ContantSup: "Need to contact support?",
        ContantTeam: "Contact our support team by clicking the button next to it",
        GetIn: "Get in touch",
        Uploadimage: "Upload image",
        Language: "Language",
        Logout: "Log out",
        NewPassword: "New password",
        ConfirmPassword: "Confirm password",
        ChangeImage: "Change image",
        Remove: "Remove",
        UserEdittedSuccessfully: "User was successfully updated"
    },
    BatchActionModal: {
        actionLabel: "Document actions",
        actionSublabel: "View the approvable and non-approvable documents based on the batch actions.",
        batchAprovable: "Approvable in batches",
        nonBatchAprovable: "Non-approvable",
        documentName: "Document's name",
        reproveButton: "Disapprove documents",
        aproveDocument: "Approve documents",
        approvedDocuments: "Documents approved successfully!",
        approvedDocumentsSub: "The documents listed below have been approved successfully.",
        concluded: "Conclude",
        reprovedDocuments: "Documents rejected successfully!",
        reprovedDocumentsSub: "The documents listed below have been rejected successfully."
      },
    DocumentsList: {
      DocumentsTableHeaders: {
        Name: "Name",
        Description: "Description",
        CreatedAt: "Created at",
        Tags: "Tags",
        Size: "Size",
        Term: "Term",
      },
      SeeDocuments: "See Documents"
    },
    SearchBox: {
        recentSearches: "Recents Searches",
        noRecentLists: "No recent searches",
        searchButton: "Search",
        cleanSearches: "Clean Search",
        seeAllResults: "See all results",
        tryOtherWords: "Try searching with other words to try to find what you are looking for.",
        nothingFound: "Nothing found",
        bestResults: "Best results",
        searchForContent: "Search about content",
        allWorkspaces: "All Workspaces",
        inThatPage: "In that page",
        myFolderAndFiles: "My folders and files",
        selectOrg: "Select your organization.",
        selectedWorkspace: "Select your workspace.",
        default: "Default"
    },
    PasswordMessage: {
      MinLength: "Password is shorter than expected. Minimum is 6.",
      AtLeastOneNumber: "Password requires at least 1 number.",
      EspecialValidation: "Password requires at least one special character.",
      UppercaseValidation: "Password requires at least one uppercase character.",
      DiffPass: "Passwords differ.",
      StartProcess: "Type your current password...",
      changedSuccessfully: "Password changed successfully."
    },
    Language: {
      Language: "Language",
      SelectPreferIdiom: "Select your preferred language.",
      NotFoundLanguage: "Can't find your language? Contact our support to request a specific language."
    },
    OpeningDocumentInWindows: {
      message: "Opening document in Windows",
    },
    DownloadAgentModal: {
      haveThe: "Have the",
      onYourComputer: "on your computer",
      toViewTheSelectedItemOnYourComputerClickTheButtonBelowToDownloadAndInstallThe: "To view the selected item on your computer, click the button below to download and install the",
      cancel: "Cancel",
      downloadKeyDriveLocalEdit: "Download KeyDriveLocalEdit",
      openInApplication: "Open in application",
      OpeningDocumentInKeyDriveLocalEdit: "Opening document in KeyDriveLocalEdit",
      UnsupportedBrowser: "Unsupported browser",
    },
    MoveInBatch: {
      "title": "Move selected items?",
      "header": "Please confirm if you really want to move all the selected items below. Finally, set the destination for the items.",
      "titleListItens": "Selected items",
      "titleMoveFor": "Move to",
      "checkbox": "Move to Workspace root"
    },
    MovedSuccess: {
      "title": "Items moved successfully",
      "header": "All set! The selected items have been successfully moved. Check them out below:",
      "goToLocation": "Go to location",
      "finish": "Finish"
    },
    BoxMfa: {
      title: "Two-Factor Authentication",
      button: "Return to login"
    },
    MfaQRCode: {
      header: "Follow the steps below to access your account.",
      tooltip: "Copy code",
      tipPartA: "Can't scan the code?",
      tipPartB: " Copy the code above and paste it into your authenticator.",
      tipOnePartA: "Scan the QR Code",
      tipOnePartB: " on the side using the authentication app (e.g., Authenticator).",
      tipTwo: "After scanning, enter the 6-digit code received in the fields below:"
    },
    MfaOTP: {
      header: "You already have the QR Code. Now, enter the code received in your authenticator app in the fields below:",
      buttonNotQRCode: "I don't have the QR Code"
    },
    Paywall: {
      title: "You have reached the maximum allowed!",
      workspaceStart: "You can only have " ,
      workspaceBold: "one Workspace on the free plan. ",
      workspaceEnd: "Contact support and request an upgrade to your Organization's plan.",
      usersStart: "You can only have  ",
      usersBold: "three users on the free plan. ",
      usersEnd: "Contact support and request an upgrade to your Organization's plan.",
      storageStart: "You can only use up to  ",
      storageBold: "4GB of storage on the free plan. ",
      storageEnd: "Contact support and request an upgrade to your Organization's plan.",
      storageWithAdminContact: "You can only use up to  ",
      storageWithAdminContactBold: "4GB of storage on the free plan. ",
      storageWithAdminContactEnd: "Contact the admin user and request an upgrade to the Organization's plan.",
      validationRuleStart: "You can only have ",
      validationRuleBold: "one Validation rule on the free plan. ",
      validationRuleEnd: "Contact support and request an upgrade to your Organization's plan.",
      upgrade: "Do a upgrade",
      gotIt: "Got it",
      error: "Error while requesting organization data, please try again"
    },
    PleaseWaitTheOrganizationIsBeingCreated: {
      message: "Please wait, the organization is being created."
    },
    RegisterPage: {
      pageTitle: "Create an account",
      pageDescription: "Let's go through all the steps below to create a new account for you",
      steps: {
        step1: {
          title: "Personal Information",
          content: "Start by entering your basic information"
        },
        step2: {
          title: "Choose a password",
          content: "Create a secure password to protect your account and your data."
        },
        step3: {
          title: "Organization Information",
          content: "Define the organization name and after account creation, create workspaces to store your documents."
        },
        step4: {
          title: "Choose a plan",
          content: "Select the plan that best meets your needs at this time."
        },
        step5: {
          title: "Confirm and finish",
          content: "Make sure everything is correct and complete the account creation."
        }
      },
    },
    SharedItem: {
        Title: "Shared",
        Subtitle: "Here you can view all the folders and files that have been shared with collaborator users.",
        NotFound: {
          Title: "No shared items",
          Subtitle: "No items have been shared so far."
        },
        name: "Name",
        dateShared: "Date of expiration",
        sharedBy: "Shared by",
        usersWithAccess: "Users with access",
        users: "Users",
        theDocument : "The document",
        hasBeenSharedSuccessfully : "has been shared successfully.",
        favoriteSuccess: "Document successfully favorited.",
        favoriteFail: "favorite already exists.",
        unfavoriteSuccess: "Document successfully unfavorited.",
        unfavoriteFail: "Error while unfavoriting.",
        unsharedSuccess: "Unshared with",
        unsharedFail: "Error unshare.",
        all: "all",
        noExpiration: "No expiration",
      },
      GenericTablePagination: {
        showing: "Showing",
        itemsOutOf: "items out of",
        totalItems: "total items."
      },
      ItemOptionsMenu: {
      download: "Download",
      edit: "Edit",
      copyLink: "Copy link",
      favorite: "Favorite",
      unfavorite: "Unfavorite",
      unshared: "Unshared",
      all: "All"
    },
    ButtonWithPopoverFilter : {
      filters: "Filters",
      viewAll: "View all",
      myFiles: "My files",
      sharedBy: "Shared by",
      select: "Select...",
      sharedDate: "Shared date",
      start: "Start",
      end: "End",
      reset: "Reset",
      applyFilter: "Apply filter"
    },
    NewFolder: {
      title: "New folder"
    },
    WorkspaceList: {
      Documents: "Documents",
      HeaderText: "Manage your documents: easily track the status of pending items, approvals, and rejections.",
      DocumentActions: "Document actions",
      New: "New",
      NoItens: "No items here",
      NoItensText: "Unfortunately, there are no documents or folders available at the moment."
    },
    DocumentActionsMenu: {
      draft: "Draft",
      download: "Download",
      release: "Release",
      moveTo: "Move to",
      preValidationOfAction: "Pre-validation of action"
    },
    Payment: {
      CancelSubscriptionSuccess: "You have canceled your subscription. You will still be able to use our services until the due date of your next month's payment.",
      CancelSubscriptionTitle: "Unfortunately, your subscription has been canceled."
    },
    DecideLater: { 
      Title: "Decide the plan later?", 
      Content: "If you continue, you will be able to decide the plan later (without the trial period), in our plans tab. You will have minimal access to the software.", 
      Later: "Decide later", 
      Cancel: "Cancel" 
    },
    AddNewDevice: {
      NewDeviceDetectedTitle: "New sign-in detected on your account",
      NewDeviceDetectedContent: "We detected a new sign-in to your KeyDrive account. To ensure the security of your data, we want to confirm if it was you.",
      AuthorizeDevice: "Authorize device",
      MessagedSentFor: "This message was sent by",
      Bom: "© 2025 KeyDrive. All rights reserved."
    },
  }
}
